var map = {
	"./bigTruck/bigTruck-dark-grey.png": "48ff",
	"./bigTruck/bigTruck-grey.png": "820d",
	"./bus/bus-dark-grey.png": "e223",
	"./bus/bus-grey.png": "d558",
	"./car/car-dark-grey.png": "6316",
	"./car/car-grey.png": "933e",
	"./container/container-dark-grey.png": "33ab",
	"./container/container-grey.png": "c4be",
	"./doubleCabin/doubleCabin-dark-grey.png": "4ea0",
	"./doubleCabin/doubleCabin-grey.png": "4741",
	"./electricCar/electricCar-dark-grey.png": "9873",
	"./electricCar/electricCar-grey.png": "7f2c",
	"./electricMotorcycle/electricMotorcycle-dark-grey.png": "60e2",
	"./electricMotorcycle/electricMotorcycle-grey.png": "e57a",
	"./excavator/excavator-dark-grey.png": "c550",
	"./excavator/excavator-grey.png": "90dd",
	"./motorcycle/motorcycle-dark-grey.png": "b8a6",
	"./motorcycle/motorcycle-grey.png": "fcc1",
	"./smallTruck/smallTruck-dark-grey.png": "b437",
	"./smallTruck/smallTruck-grey.png": "c897",
	"./tractor/tractor-dark-grey.png": "2d98",
	"./tractor/tractor-grey.png": "9b87",
	"./truckHead/truckHead-dark-grey.png": "8bf1",
	"./truckHead/truckHead-grey.png": "4c48",
	"./van/van-dark-grey.png": "ebe9",
	"./van/van-grey.png": "7854"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10b7";